import type { IPublicClientApplication } from "@azure/msal-browser";
import { InteractionStatus } from "@azure/msal-browser";
import { Client } from "@microsoft/microsoft-graph-client";
import { getAccessTokenUsingMsal } from "@skanska/vsa-client-auth";

class GraphClientService {
  private static instance: GraphClientService;
  private graphClient: Client | null = null;

  private constructor() {}

  public static getInstance(): GraphClientService {
    if (!GraphClientService.instance) {
      GraphClientService.instance = new GraphClientService();
    }
    return GraphClientService.instance;
  }

  public async initializeGraphClient(
    inProgress: InteractionStatus,
    msalInstance: IPublicClientApplication,
    tenantId: string,
    scopes: string[] = ["GroupMember.Read.All"]
  ): Promise<Client> {
    if (this.graphClient) {
      return this.graphClient;
    }

    this.graphClient = Client.initWithMiddleware({
      authProvider: {
        getAccessToken: async () => {
          try {
            const accessToken = await getAccessTokenUsingMsal(
              inProgress,
              msalInstance,
              scopes,
              tenantId
            );
            return accessToken;
          } catch (error) {
            console.error("Error getting access token:", error);
            throw Object.assign(
              new Error("Failed to get access token for Graph API"),
              { cause: error }
            );
          }
        },
      },
    });

    return this.graphClient;
  }
}

export default GraphClientService;
